import { CommonModule } from '@angular/common';
import { Component, ViewChild, OnInit, EventEmitter, Output } from '@angular/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { CommonFunctionsService } from '../../../services/common-functions.service';
import { CommonDataService } from '../../../services/common-data.service';
import { Constants } from '../../../constants/constants';
import { MatIconModule } from '@angular/material/icon';
import { MessageDialogService } from '../../../services/message-dialog.service';
import { MatDialog } from '@angular/material/dialog';
import { ReviewDetails } from '../../../models/ReviewDetails';
import { NotesExportDialogComponent } from '../../dialog/notes-export-dialog/notes-export-dialog.component';
import { Subject, takeUntil } from 'rxjs';
import { ReviewService } from '../../../services/review.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { CustomMatPaginatorIntl } from '../../../services/custom-mat-paginator.service';
import { ExportObjectAsFieldValuePDFOptions } from '../../../models/ExportObjectAsFieldValuePDFOptions';
import { ExportTablesToPDFOptions } from '../../../models/ExportTableToPDF';
import { HoursByLevel } from '../../../models/HoursByLevel';
import { TaskByLevelWithNotes } from '../../../models/TaskByLevelWithNotes';
import { ConditionByLevelWithNotesDetails } from '../../../models/ConditionByLevelWithNotesDetails';
@Component({
  selector: 'app-hoursandtasks',
  imports: [
    CommonModule,
    MatGridListModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatSelectModule,
    MatIconModule,
    TranslatePipe
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl }
  ],
  templateUrl: './sol-hours_and_tasks.component.html',
  styleUrl: './sol-hours_and_tasks.component.scss',
  standalone: true
})

export class Sol_HoursandtasksComponent implements OnInit {

  @ViewChild(MatSort) levelSort: MatSort | null = null;
  @ViewChild(MatPaginator) levelPaginator: MatPaginator | null = null;
  @ViewChild('taskPaginator') taskPaginator: MatPaginator | null = null;
  @ViewChild('conditionPaginator') conditionPaginator: MatPaginator | null = null;
  levelWiseDataList: HoursByLevel[] = [];
  dataSourceLevelWise = new MatTableDataSource<HoursByLevel>(this.levelWiseDataList);
  taskByLevelWithNotesDataList: TaskByLevelWithNotes[] = [];
  dataSourceTaskByLevelWithNotes = new MatTableDataSource<TaskByLevelWithNotes>(this.taskByLevelWithNotesDataList);
  tables: { displayedColumns: string[], dataSource: MatTableDataSource<any>, showTable: boolean }[] = [];
  selectedTable: { displayedColumns: string[], dataSource: MatTableDataSource<any> } | null = null;
  selectedLevelId: string | null = null;
  isRowSelected: boolean = false;
  selectedRowId: string | null = null;
  selectedRow: HoursByLevel | null = null;
  hoursByLevelDetails: HoursByLevel[] = new Array<HoursByLevel>();
  taskByLevelWithNotesDetails: TaskByLevelWithNotes[] = new Array<TaskByLevelWithNotes>();
  conditionByLevelWithNotesDetails: ConditionByLevelWithNotesDetails[] = new Array<ConditionByLevelWithNotesDetails>();
  conditionWiseDataList: ConditionByLevelWithNotesDetails[] = [];
  dataSourceConditionWise = new MatTableDataSource<ConditionByLevelWithNotesDetails>(this.conditionWiseDataList);
  checkDataExists: boolean = false;
  pageSizeLevelWise: number = 10;
  constants = Constants;
  destroy$ = new Subject<void>();
  @Output() disablePdf = new EventEmitter<boolean>();
  
  constructor(public commonFunctions: CommonFunctionsService, private commonDataService: CommonDataService, private messageService: MessageDialogService, private dialog: MatDialog, readonly reviewService: ReviewService, private translate: TranslateService) {
  }

  ngOnInit() {
    this.initializeHoursByLevelDetails();
    this.commonDataService.triggerTabMethod$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.exportToPdf(this.reviewService.selectedReview, Constants.SOL_HOURS_TASKS);
      });
    this.sendDisablePdfEvent();
  }

  sendDisablePdfEvent() {
    this.disablePdf.emit(false);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    this.dataSourceLevelWise.paginator = this.levelPaginator;
    this.dataSourceTaskByLevelWithNotes.paginator = this.taskPaginator;
    this.dataSourceConditionWise.paginator = this.conditionPaginator;
    this.dataSourceLevelWise.sort = this.levelSort;
    if (this.levelPaginator) {
      this.levelPaginator.pageSize = this.pageSizeLevelWise;
    }
    if (this.taskPaginator) {
      this.taskPaginator.pageSize = this.constants.TEN;
    }
    if (this.conditionPaginator) {
      this.conditionPaginator.pageSize = this.pageSizeLevelWise;
    }
  }

  hoursColumns: { field: string, header: string, isRightAlign: boolean, colWidth: string }[] = [
    { field: 'levelID', header: 'REVIEW_SOL_HOURS_TASKS_TAB.LEVEL_ID', isRightAlign: false, colWidth: 'auto' },
    { field: 'levelDescription', header: 'REVIEW_SOL_HOURS_TASKS_TAB.LEVEL', isRightAlign: false, colWidth: '250px' },
    { field: 'description', header: 'REVIEW_SOL_HOURS_TASKS_TAB.LEVEL_DESCRIPTION', isRightAlign: false, colWidth: 'auto' },
    { field: 'difficulty', header: 'REVIEW_SOL_HOURS_TASKS_TAB.DIFFICULTY', isRightAlign: false, colWidth: 'auto' },
    { field: 'typicalOfCount', header: 'REVIEW_SOL_HOURS_TASKS_TAB.TYPICAL_OF_COUNT', isRightAlign: false, colWidth: 'auto' },
    { field: 'hardwarePoints', header: 'REVIEW_SOL_HOURS_TASKS_TAB.HARDWARE_POINTS', isRightAlign: false, colWidth: 'auto' },
    { field: 'fln', header: 'REVIEW_SOL_HOURS_TASKS_TAB.FLN', isRightAlign: false, colWidth: 'auto' },
    { field: 'softwarePoints', header: 'REVIEW_SOL_HOURS_TASKS_TAB.SOFTWARE_POINTS', isRightAlign: false, colWidth: 'auto' },
    { field: 'totalPoints', header: 'REVIEW_SOL_HOURS_TASKS_TAB.TOTAL_POINTS', isRightAlign: false, colWidth: 'auto' },
    { field: 'pm', header: 'REVIEW_SOL_HOURS_TASKS_TAB.PM', isRightAlign: true, colWidth: 'auto' },
    { field: 'eng', header: 'REVIEW_SOL_HOURS_TASKS_TAB.ENG', isRightAlign: true, colWidth: 'auto' },
    { field: 'ceng', header: 'REVIEW_SOL_HOURS_TASKS_TAB.CENG', isRightAlign: true, colWidth: 'auto' },
    { field: 'eeng', header: 'REVIEW_SOL_HOURS_TASKS_TAB.EENG', isRightAlign: true, colWidth: 'auto' },
    { field: 'leng', header: 'REVIEW_SOL_HOURS_TASKS_TAB.LENG', isRightAlign: true, colWidth: 'auto' },
    { field: 'neng', header: 'REVIEW_SOL_HOURS_TASKS_TAB.NENG', isRightAlign: true, colWidth: 'auto' },
    { field: 'qeng', header: 'REVIEW_SOL_HOURS_TASKS_TAB.QENG', isRightAlign: true, colWidth: 'auto' },
    { field: 'grap', header: 'REVIEW_SOL_HOURS_TASKS_TAB.GRAP', isRightAlign: true, colWidth: 'auto' },
    { field: 'prog', header: 'REVIEW_SOL_HOURS_TASKS_TAB.PROG', isRightAlign: true, colWidth: 'auto' },
    { field: 'spec', header: 'REVIEW_SOL_HOURS_TASKS_TAB.SPEC', isRightAlign: true, colWidth: 'auto' },
    { field: 'dds', header: 'REVIEW_SOL_HOURS_TASKS_TAB.DDS', isRightAlign: true, colWidth: 'auto' },
    { field: 'mech', header: 'REVIEW_SOL_HOURS_TASKS_TAB.MECH', isRightAlign: true, colWidth: 'auto' },
    { field: 'elec', header: 'REVIEW_SOL_HOURS_TASKS_TAB.ELEC', isRightAlign: true, colWidth: 'auto' },
    { field: 'totalHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.TOTAL_HOURS', isRightAlign: true, colWidth: 'auto' },
    { field: 'totalCost', header: 'REVIEW_SOL_HOURS_TASKS_TAB.TOTAL_COST', isRightAlign: true, colWidth: 'auto' },
    { field: 'typicalHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.TYPICAL_HOURS', isRightAlign: true, colWidth: 'auto' },
    { field: 'typicalCost', header: 'REVIEW_SOL_HOURS_TASKS_TAB.TYPICAL_COST', isRightAlign: true, colWidth: 'auto' },
    { field: 'notes', header: 'REVIEW_SOL_HOURS_TASKS_TAB.NOTES', isRightAlign: false, colWidth: '350PX' },
  ];

  taskColumns: { field: string, header: string, isRightAlign: boolean, colWidth: string }[] = [
    { field: 'levelID', header: 'REVIEW_SOL_HOURS_TASKS_TAB.LEVEL_ID', isRightAlign: false, colWidth: 'auto' },
    { field: 'levelDescription', header: 'REVIEW_SOL_HOURS_TASKS_TAB.LEVEL', isRightAlign: false, colWidth: 'auto' },
    { field: 'taskID', header: 'REVIEW_SOL_HOURS_TASKS_TAB.TASK_ID', isRightAlign: false, colWidth: 'auto' },
    { field: 'taskDescription', header: 'REVIEW_SOL_HOURS_TASKS_TAB.TASK_DESCRIPTION', isRightAlign: false, colWidth: 'auto' },
    { field: 'pmHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.PM', isRightAlign: true, colWidth: 'auto' },
    { field: 'engHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.ENG', isRightAlign: true, colWidth: 'auto' },
    { field: 'cengHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.CENG', isRightAlign: true, colWidth: 'auto' },
    { field: 'eengHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.EENG', isRightAlign: true, colWidth: 'auto' },
    { field: 'lengHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.LENG', isRightAlign: true, colWidth: 'auto' },
    { field: 'nengHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.NENG', isRightAlign: true, colWidth: 'auto' },
    { field: 'qengHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.QENG', isRightAlign: true, colWidth: 'auto' },
    { field: 'grapHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.GRAP', isRightAlign: true, colWidth: 'auto' },
    { field: 'progHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.PROG', isRightAlign: true, colWidth: 'auto' },
    { field: 'specHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.SPEC', isRightAlign: true, colWidth: 'auto' },
    { field: 'ddsHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.DDS', isRightAlign: true, colWidth: 'auto' },
    { field: 'mechHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.MECH', isRightAlign: true, colWidth: 'auto' },
    { field: 'elecHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.ELEC', isRightAlign: true, colWidth: 'auto' },
    { field: 'servicingOffice', header: 'REVIEW_SOL_HOURS_TASKS_TAB.SERV_OFFICE', isRightAlign: false, colWidth: 'auto' },
    { field: 'notes', header: 'REVIEW_SOL_HOURS_TASKS_TAB.NOTES', isRightAlign: false, colWidth: 'auto' },
    { field: 'typicalOfCount', header: 'REVIEW_SOL_HOURS_TASKS_TAB.TYPICAL_OF', isRightAlign: false, colWidth: 'auto' }
  ]

  conditionColumns: { field: string, header: string, isRightAlign: boolean, colWidth: string }[] = [
    { field: 'levelID', header: 'Level ID', isRightAlign: false, colWidth: 'auto' },
    { field: 'levelDescription', header: 'Level', isRightAlign: false, colWidth: '200px' },
    { field: 'conditionID', header: 'REVIEW_SOL_HOURS_TASKS_TAB.CONDITION_ID', isRightAlign: false, colWidth: 'auto' },
    { field: 'conditionDescription', header: 'REVIEW_SOL_HOURS_TASKS_TAB.CONDITION_DESCRIPTION', isRightAlign: false, colWidth: 'auto' },
    { field: 'pmHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.PM', isRightAlign: true, colWidth: 'auto' },
    { field: 'engHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.ENG', isRightAlign: true, colWidth: 'auto' },
    { field: 'cengHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.CENG', isRightAlign: true, colWidth: 'auto' },
    { field: 'eengHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.EENG', isRightAlign: true, colWidth: 'auto' },
    { field: 'lengHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.LENG', isRightAlign: true, colWidth: 'auto' },
    { field: 'nengHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.NENG', isRightAlign: true, colWidth: 'auto' },
    { field: 'qengHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.QENG', isRightAlign: true, colWidth: 'auto' },
    { field: 'grapHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.GRAP', isRightAlign: true, colWidth: 'auto' },
    { field: 'progHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.PROG', isRightAlign: true, colWidth: 'auto' },
    { field: 'specHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.SPEC', isRightAlign: true, colWidth: 'auto' },
    { field: 'ddsHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.DDS', isRightAlign: true, colWidth: 'auto' },
    { field: 'mechHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.MECH', isRightAlign: true, colWidth: 'auto' },
    { field: 'elecHours', header: 'REVIEW_SOL_HOURS_TASKS_TAB.ELEC', isRightAlign: true, colWidth: 'auto' },
    { field: 'servicingOffice', header: 'REVIEW_SOL_HOURS_TASKS_TAB.SERV_OFFICE', isRightAlign: false, colWidth: 'auto' },
    { field: 'notes', header: 'REVIEW_SOL_HOURS_TASKS_TAB.NOTES', isRightAlign: false, colWidth: 'auto' },
    { field: 'typicalOfCount', header: 'REVIEW_SOL_HOURS_TASKS_TAB.TYPICAL_OF', isRightAlign: false, colWidth: 'auto' }
  ]

  displayedColumnsLevelWise: string[] = [
    'levelDescription',
    'difficulty',
    'typicalOfCount',
    'hardwarePoints',
    'fln',
    'softwarePoints',
    'totalPoints',
    'pm',
    'eng',
    'ceng',
    'eeng',
    'leng',
    'neng',
    'qeng',
    'grap',
    'prog',
    'spec',
    'dds',
    'mech',
    'elec',
    'totalHours',
    'totalCost',
    'typicalHours',
    'typicalCost',
    'notes'
  ];

  displayedColumnsTasksWise: string[] = [
    'levelDescription',
    'taskID',
    'taskDescription',
    'pmHours',
    'engHours',
    'cengHours',
    'eengHours',
    'lengHours',
    'nengHours',
    'qengHours',
    'grapHours',
    'progHours',
    'specHours',
    'ddsHours',
    'mechHours',
    'elecHours',
    'servicingOffice',
    'notes',

  ];

  displayedColumnsConditionWise: string[] = [
    'levelDescription',
    'conditionID',
    'conditionDescription',
    'pmHours',
    'engHours',
    'cengHours',
    'eengHours',
    'lengHours',
    'nengHours',
    'qengHours',
    'grapHours',
    'progHours',
    'specHours',
    'ddsHours',
    'mechHours',
    'elecHours',
    'servicingOffice',
    'notes',
  ];

  rightAlignColumnsConditionWise: string[] = [
    'pmHours',
    'engHours',
    'nengHours',
    'qengHours',
    'cengHours',
    'eengHours',
    'lengHours',
    'grapHours',
    'progHours',
    'specHours',
    'ddsHours',
    'mechHours',
    'elecHours',
  ];

  initializeHoursByLevelDetails() {
    const newCostReviewObject = this.reviewService.newCostReviewObject;
    if (newCostReviewObject) {
      this.hoursByLevelDetails = this.formatHoursByLevelDetails(newCostReviewObject.hoursByLevelDetails || []);
      this.taskByLevelWithNotesDetails = this.formatTaskDetails(newCostReviewObject.taskByLevelWithNotesDetails || []) as TaskByLevelWithNotes[];
      this.conditionByLevelWithNotesDetails = this.formatTaskDetails(newCostReviewObject.conditionByLevelWithNotesDetails || []) as ConditionByLevelWithNotesDetails[];
      this.checkDataExists = this.hoursByLevelDetails.length > Constants.ZERO;
      if (this.checkDataExists) {
        this.getAllMappedLevelWise();
      }
      if (this.taskByLevelWithNotesDetails.length && this.checkDataExists) {
        this.getAllMappedTaskByLevelWithNotes();
        this.getAllMappedConditionByLevelWithNotes();
      }
    }
    this.commonFunctions.stopSpinner();
  }

  formatHoursByLevelDetails(details: HoursByLevel[]): HoursByLevel[] {
    return JSON.parse(JSON.stringify(details)).map((detail: HoursByLevel) => ({
      ...detail,
      pm: this.commonFunctions.formatToTwoDecimal(detail.pm),
      eng: this.commonFunctions.formatToTwoDecimal(detail.eng),
      grap: this.commonFunctions.formatToTwoDecimal(detail.grap),
      prog: this.commonFunctions.formatToTwoDecimal(detail.prog),
      spec: this.commonFunctions.formatToTwoDecimal(detail.spec),
      dds: this.commonFunctions.formatToTwoDecimal(detail.dds),
      mech: this.commonFunctions.formatToTwoDecimal(detail.mech),
      elec: this.commonFunctions.formatToTwoDecimal(detail.elec),
      neng: this.commonFunctions.formatToTwoDecimal(detail.neng),
      qeng: this.commonFunctions.formatToTwoDecimal(detail.qeng),
      ceng: this.commonFunctions.formatToTwoDecimal(detail.ceng),
      eeng: this.commonFunctions.formatToTwoDecimal(detail.eeng),
      leng: this.commonFunctions.formatToTwoDecimal(detail.leng),
      totalHours: this.commonFunctions.formatToTwoDecimal(detail.totalHours),
      totalCost: this.commonFunctions.formatToTwoDecimal(detail.totalCost),
      typicalHours: this.commonFunctions.formatToTwoDecimal(Number(detail.typicalOfCount === Constants.NA ? Constants.ONE : detail.typicalOfCount) * Number(detail.totalHours)),
      typicalCost: this.commonFunctions.formatToTwoDecimal(Number(detail.typicalOfCount === Constants.NA ? Constants.ONE : detail.typicalOfCount) * Number(detail.totalCost)),
    }));
  }

  formatTaskDetails(details: TaskByLevelWithNotes[] | ConditionByLevelWithNotesDetails[]): TaskByLevelWithNotes[] | ConditionByLevelWithNotesDetails[] {
    return JSON.parse(JSON.stringify(details)).map((detail: TaskByLevelWithNotes | ConditionByLevelWithNotesDetails) => ({
      ...detail,
      pmHours: this.commonFunctions.formatToTwoDecimal(detail.pmHours),
      engHours: this.commonFunctions.formatToTwoDecimal(detail.engHours),
      grapHours: this.commonFunctions.formatToTwoDecimal(detail.grapHours),
      progHours: this.commonFunctions.formatToTwoDecimal(detail.progHours),
      specHours: this.commonFunctions.formatToTwoDecimal(detail.specHours),
      ddsHours: this.commonFunctions.formatToTwoDecimal(detail.ddsHours),
      mechHours: this.commonFunctions.formatToTwoDecimal(detail.mechHours),
      elecHours: this.commonFunctions.formatToTwoDecimal(detail.elecHours),
      nengHours: this.commonFunctions.formatToTwoDecimal(detail.nengHours),
      qengHours: this.commonFunctions.formatToTwoDecimal(detail.qengHours),
      cengHours: this.commonFunctions.formatToTwoDecimal(detail.cengHours),
      eengHours: this.commonFunctions.formatToTwoDecimal(detail.eengHours),
      lengHours: this.commonFunctions.formatToTwoDecimal(detail.lengHours),
    }));
  }


  getAllMappedLevelWise() {
    if (this.hoursByLevelDetails.length) {
      this.levelWiseDataList = this.hoursByLevelDetails.map(detail => {
        let difficulty;
        switch (detail.difficulty) {
          case Constants.SOL_DIFFICULTY_LEVEL_NONE:
            difficulty = Constants.NONE_HOURS_AND_TASK_DIFFICULTY_LEVEL;
            break;
          case Constants.SOL_DIFFICULTY_LEVEL_SIMPLE:
            difficulty = Constants.SIM_HOURS_AND_TASK_DIFFICULTY_LEVEL;
            break;
          case Constants.SOL_DIFFICULTY_LEVEL_STANDARD:
            difficulty = Constants.MED_HOURS_AND_TASK_DIFFICULTY_LEVEL;
            break;
          case Constants.SOL_DIFFICULTY_LEVEL_COMPLEX:
            difficulty = Constants.COM_HOURS_AND_TASK_DIFFICULTY_LEVEL;
            break;
          default:
            difficulty = detail.difficulty;
        }
        return {
          ...detail,
          difficulty
        };
      });
      this.dataSourceLevelWise.data = this.levelWiseDataList;
    }
  }

  getAllMappedTaskByLevelWithNotes() {
    if (this.taskByLevelWithNotesDetails.length > Constants.ZERO) {
      this.taskByLevelWithNotesDataList = this.taskByLevelWithNotesDetails.filter(detail => detail.levelDescription !== Constants.SUMMARY && detail.levelID !== Constants.DEFAULT_VALUE_FOR_HOURS_TASKS);
      this.dataSourceTaskByLevelWithNotes.data = this.taskByLevelWithNotesDataList.map((item, index, array) => {
        if (index > Constants.ZERO && item.levelDescription === array[index - Constants.ONE].levelDescription) {
          return { ...item, levelDescription: Constants.EMPTY_STRING };
        }
        this.conditionWiseDataList.forEach((dataItem: ConditionByLevelWithNotesDetails) => {
          const fieldsToCheck = this.rightAlignColumnsConditionWise;
          fieldsToCheck.forEach(field => {
            if (String(dataItem[field as keyof ConditionByLevelWithNotesDetails]) === Constants.NEGATIVE_INFINITE) {
              (dataItem as Record<string, any>)[field] = Constants.NA;
            }
          });
        });
        return item;
      });
    }
  }

  getAllMappedConditionByLevelWithNotes() {
    if (this.conditionByLevelWithNotesDetails.length) {
      this.conditionWiseDataList = this.conditionByLevelWithNotesDetails
        .filter(detail => detail.levelDescription !== Constants.SUMMARY && detail.levelID !== Constants.DEFAULT_VALUE_FOR_HOURS_TASKS)

      this.dataSourceConditionWise.data = this.conditionWiseDataList.map((item, index, array) => {
        if (index > Constants.ZERO && item.levelDescription === array[index - Constants.ONE].levelDescription) {
          return { ...item, levelDescription: Constants.EMPTY_STRING };
        }
         this.conditionWiseDataList.forEach((dataItem: ConditionByLevelWithNotesDetails) => {
           const fieldsToCheck = this.rightAlignColumnsConditionWise;
           fieldsToCheck.forEach(field => {
             if (String(dataItem[field as keyof ConditionByLevelWithNotesDetails]) === Constants.NEGATIVE_INFINITE) {
               (dataItem as Record<string, any>)[field] = Constants.NA;
             }
           });
         });
        return item;
      });
    }
  }

  onHourByLevelColumnClicked(row: HoursByLevel) {
    if (!row) {
      return;
    }
    const levelId = row.levelId;
    if (this.selectedRow === row) {
      this.clearSelectedRow();
    } else {
      this.setSelectedRow(row, levelId);
    }
    if (this.taskPaginator) {
      this.taskPaginator.firstPage();
    }
    if (this.conditionPaginator) {
      this.conditionPaginator.firstPage();
    }
  }

  clearSelectedRow() {
    this.selectedRow = null;
    this.isRowSelected = false;
    this.selectedRowId = null;

    this.dataSourceTaskByLevelWithNotes.data = this.getSortedTaskByLevelWithNotesData(this.taskByLevelWithNotesDataList);
    this.dataSourceConditionWise.data = this.getSortedConditionByLevelWithNotesData(this.conditionWiseDataList);
  }

  setSelectedRow(row: HoursByLevel, levelId: string) {
    this.selectedRow = row;
    this.isRowSelected = true;
    this.selectedRowId = levelId;

    const filteredTasks = this.taskByLevelWithNotesDataList.filter(task => task.levelID === levelId);
    const filteredCondtions = this.conditionWiseDataList.filter(condition => condition.levelID === levelId);
    this.dataSourceTaskByLevelWithNotes.data = this.getSortedTaskByLevelWithNotesData(filteredTasks);
    this.dataSourceConditionWise.data = this.getSortedConditionByLevelWithNotesData(filteredCondtions);
  }

  getSortedConditionByLevelWithNotesData(filteredCondtions: ConditionByLevelWithNotesDetails[]) {
    return filteredCondtions.map((item, index, array) => {
      if (index > Constants.ZERO && item.levelDescription === array[index - Constants.ONE].levelDescription) {
        return { ...item, levelDescription: Constants.EMPTY_STRING };
      }
      return item;
    });
  }

  getSortedTaskByLevelWithNotesData(dataList: TaskByLevelWithNotes[]) {
    return dataList.map((item, index, array) => {
      if (index > Constants.ZERO && item.levelDescription === array[index - Constants.ONE].levelDescription) {
        return { ...item, levelDescription: Constants.EMPTY_STRING };
      }
      return item;
    });
  }

  truncateText(text: string, limit: number): string {
    if (!text) {
      return this.constants.EMPTY_STRING;
    }
    return text.length > limit ? text.substring(this.constants.ZERO, limit) : text;
  }

  openNotesDialog(notes: string) {
    this.messageService.showInfoMessage(
      Constants.NOTES,
      notes
    );
  }

  includeNotesInPdf = true;
  exportToPdf(selectedReview: ReviewDetails, tabName: string) {
    if (tabName !== Constants.SOL_HOURS_TASKS) {
      return;
    }

    if (this.isAllTablesEmpty()) {
      this.exportNoDataFound(selectedReview);
      return;
    }

    const dialogRef = this.dialog.open(NotesExportDialogComponent, {
      width: '350px',
      data: { includeNotes: this.includeNotesInPdf },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result: boolean | undefined) => {
      if (result === undefined) {
        return;
      }
      this.includeNotesInPdf = result;

      const tables = [
        this.getTableConfig<HoursByLevel>(
          'REVIEW_SOL_HOURS_TASKS_TAB.TITLE',
          this.dataSourceLevelWise.data,
          this.displayedColumnsLevelWise,
          this.hoursColumns.reduce((acc, col) => {
            acc[col.field] = col.header;
            return acc;
          }, {} as { [key: string]: string }),
          this.includeNotesInPdf,
          'REVIEW_SOL_HOURS_TASKS_TAB.HOURS_TASKS_DATA_NOT_FOUND'
        ),
        this.getTableConfig<TaskByLevelWithNotes>(
          'REVIEW_SOL_HOURS_TASKS_TAB.TASK_BY_LEVEL',
          this.dataSourceTaskByLevelWithNotes.data,
          this.displayedColumnsTasksWise,
          this.taskColumns.reduce((acc, col) => {
            acc[col.field] = col.header;
            return acc;
          }, {} as { [key: string]: string }),
          this.includeNotesInPdf,
          'REVIEW_SOL_HOURS_TASKS_TAB.HOURS_TASKS_DATA_NOT_FOUND'
        ),
        this.getTableConfig<ConditionByLevelWithNotesDetails>(
          'REVIEW_SOL_HOURS_TASKS_TAB.CONDITION_BY_LEVEL',
          this.dataSourceConditionWise.data,
          this.displayedColumnsConditionWise,
          this.conditionColumns.reduce((acc, col) => {
            acc[col.field] = col.header;
            return acc;
          }, {} as { [key: string]: string }),
          this.includeNotesInPdf,
          'REVIEW_SOL_HOURS_TASKS_TAB.HOURS_TASKS_DATA_NOT_FOUND'
        )
      ];

      const options: ExportTablesToPDFOptions = {
        tables,
        fileName: 'hours_and_tasks.pdf',
        hasNotes: false,
        estimateID: selectedReview.estimateID,
        estimateName: selectedReview.request,
        tabName: this.translate.instant('REVIEW_SOL_TABS_LABELS.HOURS_TASKS'),
      };
      this.commonFunctions.exportTablesToPDF(options);
    });
  }

  private getTableConfig<T>(
    titleKey: string,
    data: T[],
    columns: string[],
    headers: { [key: string]: string },
    includeNotes: boolean,
    noDataMsgKey: string
  ) {
    return this.buildTable(
      this.translate.instant(titleKey),
      data,
      columns,
      headers,
      includeNotes,
      this.translate.instant(noDataMsgKey),
      (row: T, col: string) => {
        if (col === Constants.LEVEL_DESCRIPTION) {
          return this.commonFunctions.breakLongWords(String(row[col as keyof T]), Constants.TEN);
        }
        return row[col as keyof T];
      }
    );
  }

  private isAllTablesEmpty(): boolean {
    return (
      (!this.dataSourceLevelWise.data || this.dataSourceLevelWise.data.length === Constants.ZERO) &&
      (!this.dataSourceTaskByLevelWithNotes.data || this.dataSourceTaskByLevelWithNotes.data.length === Constants.ZERO) &&
      (!this.dataSourceConditionWise.data || this.dataSourceConditionWise.data.length === Constants.ZERO)
    );
  }

  private exportNoDataFound(selectedReview: ReviewDetails) {
    const options: ExportObjectAsFieldValuePDFOptions = {
      data: { [this.translate.instant('REVIEW_SOL_HOURS_TASKS_TAB.HOURS_TASKS_DATA_NOT_FOUND')]: Constants.EMPTY_STRING },
      title: Constants.EMPTY_STRING,
      fileName: 'hours_and_tasks.pdf',
      estimateID: selectedReview.estimateID,
      estimateName: selectedReview.request,
      tabName: this.translate.instant('REVIEW_SOL_TABS_LABELS.HOURS_TASKS'),
    };
    this.commonFunctions.exportObjectAsFieldValuePDF(options);
  }

  buildTable<T>(
    title: string,
    data: T[],
    columns: string[],
    headers: { [key: string]: string },
    includeNotes: boolean,
    noDataMsg: string,
    typeGuard?: (row: T, col: string) => any,
    columnStyles?: { [key: string]: any }
  ) {
    const filteredColumns = includeNotes ? columns : columns.filter(col => col.toLowerCase() !== Constants.NOTES.toLowerCase());
    const filteredHeaders = { ...headers };
    if (!includeNotes) {
      delete filteredHeaders[Constants.NOTES.toLowerCase()];
    }

    if (data && data.length > Constants.ZERO) {
      return {
        title,
        displayedColumns: filteredColumns,
        headers: filteredHeaders,
        data,
        typeGuard: typeGuard ? typeGuard : (row: T, col: string) => row[col as keyof T],
        columnStyles
      };
    } else {

      const emptyRow: any = {};
      filteredColumns.forEach((col, idx) => {
        emptyRow[col] = idx === 0 ? noDataMsg : Constants.EMPTY_STRING;
      });

      return {
        title,
        displayedColumns: filteredColumns,
        headers: filteredHeaders,
        data: [emptyRow],
        columnStyles
      };
    }
  }
}